import { render, staticRenderFns } from "./goodsAddress.vue?vue&type=template&id=04945d1c&scoped=true"
import script from "./goodsAddress.vue?vue&type=script&lang=js"
export * from "./goodsAddress.vue?vue&type=script&lang=js"
import style0 from "./goodsAddress.vue?vue&type=style&index=0&id=04945d1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04945d1c",
  null
  
)

export default component.exports